import React from "react";
import { AppContext } from "../../contexts/AppContext";

const NameChange = () => {
  const { appState } = React.useContext(AppContext);
  const changedName = appState?.requestPayload?.applicant;

  return (
    <React.Fragment>
      <div className="step-container">
        <h2 className="step-title mb-2">Current name details</h2>
        <div className="step-container-nospace">
          <div className="step-container-box">
            <p className="label">Given name(s)</p>
            <p className="value">{changedName.givenNames || "-"}</p>
          </div>
          <div className="step-container-box">
            <p className="label">Surname or family name</p>
            <p className="value">{changedName.familyName || "-"}</p>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default NameChange;
